import { InjectionToken } from '@angular/core'
import { ToastOptions } from './interfaces/toast-options.interface'

export const TOAST_CONFIG = new InjectionToken<ToastOptions>('ToastOptions')

export const DefaultToastConfig: Partial<ToastOptions> = {
    time: 2500,
}
